import React, {memo, useEffect, useState} from 'react';
import MaterialTable from 'material-table';
import TableIcons from '../../utils/TableIcons';
import setDate from '../../utils/setDate';
import convertToCurrency from '../../utils/convertToCurrency';
import theme from '../../styles/theme';
import _ from 'lodash';

import VisibilityIcon from '@material-ui/icons/Visibility';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import RefreshIcon from '@material-ui/icons/Refresh';
import {Box, Typography} from "@material-ui/core";

const PixelsTable = memo(({graphqlData, pixelData, variables, refetch}) => {
    const [data, setData] = useState(pixelData);
    const setIcon = (bool) => {
        if (bool) {
            return (
                <CheckIcon style={{color: theme.palette.success.main}}/>
            );
        }

        return <ClearIcon style={{color: theme.palette.error.main}}/>;
    };

    const getNameFromAffiliateId = (id) => {
        return graphqlData.allAffiliate.nodes.find(item => item.id === id).name
    }

    const getNameFromTrafficSourceId = (id) => {
        return graphqlData.allTrafficSource.nodes.find(item => item.id === id).name
    }

    const pixelHasTrafficSource = (pixel, trafficSourceId) => {
        const subscriber = pixel.pixelSubscribers.find (subscriber => subscriber.trafficSourceId === trafficSourceId);

        return !!subscriber;
    }

    const pixelHasAffiliate = (pixel, affiliateId) => {
        const subscriber = pixel.pixelSubscribers.find (subscriber => subscriber.affiliateId === affiliateId);

        return !!subscriber;
    }

    useEffect(() => {
        if (variables && Object.keys(variables).length) {
            const {affiliateId, trafficSourceId} = variables;

            let finalArr = [];

            if (trafficSourceId) {
                finalArr = data.filter(pixel => pixelHasTrafficSource(pixel, trafficSourceId));
            } else if (affiliateId) {
                finalArr = data.filter(pixel => pixelHasAffiliate(pixel, affiliateId));
            }

            setData(finalArr);
        } else {
            setData(pixelData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variables])

    return (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={[
                {title: 'Id', field: "id", hidden: true},
                {title: "Pixel Name", field: "pixelName"},
                {title: "Pixel Key", field: "pixelKey"},
                {title: "HTTP Method", field: "httpMethod"},
                {title: "URL", field: "url"},
                {
                    title: 'Subscribers', field: 'pixelSubscribers',
                    render: rowData => {
                        const { pixelSubscribers } = rowData;
                        if (!pixelSubscribers.length) {
                            return 'N/A';
                        }

                        return (
                            <ul>
                                {pixelSubscribers.map(item => (
                                    <li key={item.id }>
                                        <Typography variant="body2" style={{ paddingBottom: '5px' }}>
                                            <Box display="flex" alignItems="center">
                                                <strong>{item.affiliateId ? (
                                                    getNameFromAffiliateId(item.affiliateId)
                                                ) : (
                                                    getNameFromTrafficSourceId(item.trafficSourceId)
                                                )}</strong>
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                {item.revenueType}
                                            </Box>
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        );
                    }
                }
            ]}
            data={data.map(item => ({
                id: item.id,
                pixelName: item.pixelName || 'N/A',
                pixelKey: item.pixelKey || 'N/A',
                httpMethod: item.httpMethod || 'N/A',
                url: item.url || 'N/A',
                pixelSubscribers: item.pixelSubscribers || []
            }))}
            actions={
                [
                    {
                        icon: () => <RefreshIcon/>,
                        tooltip: 'Refetch Data',
                        isFreeAction: true,
                        onClick: (event) => refetch()
                    },
                    {
                        icon: () => <VisibilityIcon/>,
                        tooltip: 'Edit Pixel',
                        onClick: (event, rowData) => window.open(`/info/pixels/${rowData.id}`)
                    },
                ]}
            options={{
                pageSize: 100,
                pageSizeOptions: [100, 200, 300],
                headerStyle: {
                    minWidth: 'auto',
                },
                search: false,
            }}
        />
    );
});


export default PixelsTable;
